import axios from 'axios';

// General
const updateGenerativeDriver = (id) => axios.put('', { id });

// Resource
const createResource = (params) => axios.post('generative-ai/resource', params);
const deleteResource = (id) => axios.delete(`generative-ai/resource/${id}`);
const recrawlResource = (id) => axios.put(`generative-ai/resource/${id}`);
const fetchResourceAvailableTags = () => axios.get('generative-ai/resource/groups/available');
const createResourceTag = ({ name, scoped_to }) => axios.post('generative-ai/resource/groups', { name, scoped_to });
const fetchResourceTags = (resourceId) => axios.get(`generative-ai/resource/${resourceId}/groups`);
const saveResourceTags = ({ resourceId, groupIds }) => axios.post(`generative-ai/resource/${resourceId}/groups`, { groupIds });
const verifyResourceAdd = (fileId) => axios.get(`generative-ai/resource/verify/${fileId}`);

// Prompt
const fetchPrompt = () => axios.get('generative-ai/prompt');
const updatePrompt = (params) => axios.post('generative-ai/prompt', params);

// SharePoint
const connectSharePoint = (params) => axios.post('generative-ai/sharepoint/setting', params);
const disconnectSharePoint = () => axios.delete('generative-ai/sharepoint');
const selectSharePointSite = (params) => axios.put('generative-ai/sharepoint/site', params);
const verifySharePointSite = (params) => axios.post('generative-ai/sharepoint/site/verify', params);
const reverifySharePointSite = (params) => axios.post('generative-ai/sharepoint/site/reverify', params);
const selectSharePointFolder = ({ siteId, ...params }) => axios.put(`generative-ai/sharepoint/site/${siteId}/folder`, params);
const resyncSharePointSite = (siteId) => axios.post(`generative-ai/sharepoint/site/${siteId}/sync`);
const deleteSharePointSite = (siteId) => axios.delete(`generative-ai/sharepoint/site/${siteId}`);
const resyncSharePointFolder = (siteId, folderId) => axios.post(`generative-ai/sharepoint/site/${siteId}/folder/${folderId}/sync`);
const deleteSharePointFolder = (siteId, folderId) => axios.delete(`generative-ai/sharepoint/site/${siteId}/folder/${folderId}`);
const fetchSharePointTenantId = () => axios.get('generative-ai/sharepoint');
const verifySharePointCredential = (params) => axios.post('generative-ai/sharepoint/token/verify', params);
const updateSharePointCredential = (params) => axios.put('generative-ai/sharepoint/token/update', params);
const fetchSharePointAvailableTags = () => axios.get('generative-ai/sharepoint/groups/available');
const createSharePointTag = ({ name, scoped_to }) => axios.post('generative-ai/sharepoint/groups', { name, scoped_to });
const fetchSharePointTags = (resourceId) => axios.get(`generative-ai/sharepoint/file/${resourceId}/groups`);
const saveSharePointTags = ({ resourceId, groupIds }) => axios.post(`generative-ai/sharepoint/file/${resourceId}/groups`, { groupIds });

// Sitemap
const createSitemap = (params) => axios.post('generative-ai/sitemap', params);
const deleteSitemap = (id) => axios.delete(`generative-ai/sitemap/${id}`);
const recrawlSitemapUrl = (id) => axios.post(`generative-ai/sitemap/recrawl/${id}`);
const deleteSitemapUrl = (id) => axios.delete(`generative-ai/sitemap/url/${id}`);
const fetchSitemapUrl = (id) => axios.post(`generative-ai/sitemap/url/${id}`);
const fetchSitemapUrlAvailableTags = () => axios.get('generative-ai/sitemap/groups/available');
const createSitemapUrlTag = ({ name, scoped_to }) => axios.post('generative-ai/sitemap/groups', { name, scoped_to });
const fetchSitemapUrlTags = (sitemapId) => axios.get(`generative-ai/sitemap/url/${sitemapId}/groups`);
const saveSitemapUrlTags = ({ sitemapId, groupIds }) => axios.post(`generative-ai/sitemap/url/${sitemapId}/groups`, { groupIds });

// Zendesk
const getZendeskSettings = (params = {}) => axios.get('generative-ai/zendesk', { params });
const connectZendesk = (params) => axios.post('generative-ai/zendesk/connect', params);
const disconnectZendesk = () => axios.delete('generative-ai/zendesk/disconnect');
const recrawlZendeskArticle = (id) => axios.post(`generative-ai/zendesk/recrawl/${id}`);
const saveCategories = (categories) => axios.post('generative-ai/zendesk/categories', { categories });
const fetchCategories = () => axios.get('generative-ai/zendesk/categories');
const deleteCategory = (id) => axios.delete(`generative-ai/zendesk/category/${id}`);
const resyncCategory = (id) => axios.post(`generative-ai/zendesk/resync/${id}`);
const resyncAll = () => axios.post('generative-ai/zendesk/resync');
const fetchArticles = (categoryId, params = {}) => axios.get(`generative-ai/zendesk/articles/${categoryId}`, { params });
const fetchZendeskAvailableTags = () => axios.get('generative-ai/zendesk/groups/available');
const createZendeskTag = ({ name, scoped_to }) => axios.post('generative-ai/zendesk/groups', { name, scoped_to });
const fetchZendeskTags = (zendeskId) => axios.get(`generative-ai/zendesk/article/${zendeskId}/groups`);
const saveZendeskTags = ({ zendeskId, groupIds }) => axios.post(`generative-ai/zendesk/article/${zendeskId}/groups`, { groupIds });

// Confluence
const getConfluenceSettings = (params = {}) => axios.get('generative-ai/confluence', { params });
const getConfluenceOAuthRedirectUrl = () => axios.get('generative-ai/confluence/oauth/redirect');
const disconnectConfluence = () => axios.delete('generative-ai/confluence/disconnect');
const fetchConfluenceSpaces = () => axios.get('generative-ai/confluence/spaces');
const saveConfluenceSpaces = (spaces) => axios.post('generative-ai/confluence/spaces', { spaces });
const deleteConfluenceSpace = (id) => axios.delete(`generative-ai/confluence/space/${id}`);
const fetchConfluencePages = (spaceId, params = {}) => axios.get(`generative-ai/confluence/pages/${spaceId}`, { params });
const resyncConfluenceSpace = (id) => axios.post(`generative-ai/confluence/resync/${id}`);
const resyncAllConfluence = () => axios.post('generative-ai/confluence/resync');
const recrawlConfluencePage = (id) => axios.post(`generative-ai/confluence/recrawl/${id}`);

// Jira
const getJiraSettings = (params = {}) => axios.get('generative-ai/jira', { params });
const getJiraOAuthRedirectUrl = () => axios.get('generative-ai/jira/oauth/redirect');
const disconnectJira = () => axios.delete('generative-ai/jira/disconnect');
const fetchJiraProjects = () => axios.get('generative-ai/jira/projects');
const saveJiraProjects = (projects) => axios.post('generative-ai/jira/projects', { projects });
const deleteJiraProject = (id) => axios.delete(`generative-ai/jira/project/${id}`);
const fetchJiraIssues = (projectId, params = {}) => axios.get(`generative-ai/jira/issues/${projectId}`, { params });
const resyncJiraProject = (id) => axios.post(`generative-ai/jira/resync/${id}`);
const resyncAllJira = () => axios.post('generative-ai/jira/resync');
const recrawlJiraIssue = (id) => axios.post(`generative-ai/jira/recrawl/${id}`);

export {
  // General
  updateGenerativeDriver,

  // Resource
  createResource,
  deleteResource,
  recrawlResource,
  fetchResourceAvailableTags,
  createResourceTag,
  fetchResourceTags,
  saveResourceTags,
  verifyResourceAdd,

  // Prompt
  fetchPrompt,
  updatePrompt,

  // SharePoint
  connectSharePoint,
  disconnectSharePoint,
  selectSharePointSite,
  verifySharePointSite,
  reverifySharePointSite,
  selectSharePointFolder,
  resyncSharePointSite,
  deleteSharePointSite,
  resyncSharePointFolder,
  deleteSharePointFolder,
  fetchSharePointTenantId,
  verifySharePointCredential,
  updateSharePointCredential,
  fetchSharePointAvailableTags,
  createSharePointTag,
  fetchSharePointTags,
  saveSharePointTags,

  // Sitemap
  createSitemap,
  deleteSitemap,
  recrawlSitemapUrl,
  deleteSitemapUrl,
  fetchSitemapUrl,
  fetchSitemapUrlAvailableTags,
  createSitemapUrlTag,
  fetchSitemapUrlTags,
  saveSitemapUrlTags,

  // Zendesk
  getZendeskSettings,
  connectZendesk,
  disconnectZendesk,
  recrawlZendeskArticle,
  saveCategories,
  fetchCategories,
  deleteCategory,
  resyncCategory,
  resyncAll,
  fetchArticles,
  fetchZendeskAvailableTags,
  createZendeskTag,
  fetchZendeskTags,
  saveZendeskTags,

  // Confluence
  getConfluenceSettings,
  getConfluenceOAuthRedirectUrl,
  disconnectConfluence,
  fetchConfluenceSpaces,
  saveConfluenceSpaces,
  deleteConfluenceSpace,
  fetchConfluencePages,
  resyncConfluenceSpace,
  resyncAllConfluence,
  recrawlConfluencePage,

  // Jira
  getJiraSettings,
  getJiraOAuthRedirectUrl,
  disconnectJira,
  fetchJiraProjects,
  saveJiraProjects,
  deleteJiraProject,
  fetchJiraIssues,
  resyncJiraProject,
  resyncAllJira,
  recrawlJiraIssue
};